var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "responsive_wrapper" }, [
    _c("div", { staticClass: "note_text" }, [
      _vm._v(
        " Indicate if you would like to receive notifications via email or as notifications in the application "
      ),
    ]),
    _c("div", { staticClass: "mr-tb-15" }, [
      _vm._m(0),
      _vm.displayProdClsfnNotifications
        ? _c("div", { staticClass: "row_wrapper row" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "toggle_switch col-md-3 col-sm-3 col-xs-7" },
              [
                _c("small", { staticClass: "display_xs" }, [
                  _vm._v("In-app Notification"),
                ]),
                _c("label", { staticClass: "switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.productClassificationInAppPref,
                        expression: "productClassificationInAppPref",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.productClassificationInAppPref)
                        ? _vm._i(_vm.productClassificationInAppPref, null) > -1
                        : _vm.productClassificationInAppPref,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.productClassificationInAppPref,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.productClassificationInAppPref =
                                  $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.productClassificationInAppPref = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.productClassificationInAppPref = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$emit(
                            "update:prodclfn_in_app_preference",
                            $event.target.checked
                          )
                        },
                      ],
                    },
                  }),
                  _c("span", { staticClass: "slider round" }),
                ]),
                _vm.prodclfn_in_app_preference
                  ? _c("span", { staticClass: "switch_label" }, [_vm._v("On")])
                  : _c("span", { staticClass: "switch_label switch_off" }, [
                      _vm._v("Off"),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "toggle_switch email-toggle_switch col-md-3 col-sm-3 col-xs-4",
              },
              [
                _c("small", { staticClass: "display_xs" }, [_vm._v("Email")]),
                _c("label", { staticClass: "switch email-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.productClassificationEmailPref,
                        expression: "productClassificationEmailPref",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.productClassificationEmailPref)
                        ? _vm._i(_vm.productClassificationEmailPref, null) > -1
                        : _vm.productClassificationEmailPref,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.productClassificationEmailPref,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.productClassificationEmailPref =
                                  $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.productClassificationEmailPref = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.productClassificationEmailPref = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$emit(
                            "update:prodclfn_email_preference",
                            $event.target.checked
                          )
                        },
                      ],
                    },
                  }),
                  _c("span", { staticClass: "slider round" }),
                ]),
                _vm.prodclfn_email_preference
                  ? _c("span", { staticClass: "switch_label" }, [_vm._v("On")])
                  : _c("span", { staticClass: "switch_label switch_off" }, [
                      _vm._v("Off"),
                    ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm.displayRegPathwayNotifications
        ? _c("div", { staticClass: "row_wrapper row" }, [
            _vm._m(2),
            _c(
              "div",
              { staticClass: "toggle_switch col-md-3 col-sm-3 col-xs-7" },
              [
                _c("small", { staticClass: "display_xs" }, [
                  _vm._v("In-app Notification"),
                ]),
                _c("label", { staticClass: "switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.RegPathwayInAppPreference,
                        expression: "RegPathwayInAppPreference",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.RegPathwayInAppPreference)
                        ? _vm._i(_vm.RegPathwayInAppPreference, null) > -1
                        : _vm.RegPathwayInAppPreference,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.RegPathwayInAppPreference,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.RegPathwayInAppPreference = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.RegPathwayInAppPreference = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.RegPathwayInAppPreference = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$emit(
                            "update:regpathway_in_app_preference",
                            $event.target.checked
                          )
                        },
                      ],
                    },
                  }),
                  _c("span", { staticClass: "slider round" }),
                ]),
                _vm.regpathway_in_app_preference
                  ? _c("span", { staticClass: "switch_label" }, [_vm._v("On")])
                  : _c("span", { staticClass: "switch_label switch_off" }, [
                      _vm._v("Off"),
                    ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "toggle_switch email-toggle_switch col-md-3 col-sm-3 col-xs-4",
              },
              [
                _c("small", { staticClass: "display_xs" }, [_vm._v("Email")]),
                _c("label", { staticClass: "switch email-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.RegPathwayEmailPreference,
                        expression: "RegPathwayEmailPreference",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.RegPathwayEmailPreference)
                        ? _vm._i(_vm.RegPathwayEmailPreference, null) > -1
                        : _vm.RegPathwayEmailPreference,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.RegPathwayEmailPreference,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.RegPathwayEmailPreference = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.RegPathwayEmailPreference = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.RegPathwayEmailPreference = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$emit(
                            "update:regpathway_email_preference",
                            $event.target.checked
                          )
                        },
                      ],
                    },
                  }),
                  _c("span", { staticClass: "slider round" }),
                ]),
                _vm.regpathway_email_preference
                  ? _c("span", { staticClass: "switch_label" }, [_vm._v("On")])
                  : _c("span", { staticClass: "switch_label switch_off" }, [
                      _vm._v("Off"),
                    ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row_wrapper row" }, [
      _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
        _vm._v("Type"),
      ]),
      _c(
        "div",
        {
          staticClass:
            "col-md-3 col-sm-3 hide_xs in_app_label header_label_text",
        },
        [_vm._v(" In-app Notification ")]
      ),
      _c(
        "div",
        {
          staticClass: "col-md-3 col-sm-3 hide_xs header_label_text email-left",
        },
        [_vm._v("Email")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Product Classification"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Regulatory Reports"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }